import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx and tailwind-merge for optimal class merging
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Get current date range for the current month
 * Returns a string in format: YYYY-MM-01,YYYY-MM-DD
 * Where the first date is the 1st of the current month
 * and the second date is today's date
 */
export function getCurrentDateRange() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // getMonth() returns 0-11, so add 1
  const day = now.getDate();

  // Format month and day with leading zeros if needed
  const formattedMonth = month.toString().padStart(2, "0");
  const formattedDay = day.toString().padStart(2, "0");

  // Return range from 1st of current month to today
  return `${year}-${formattedMonth}-01,${year}-${formattedMonth}-${formattedDay}`;
}
